// extracted by mini-css-extract-plugin
module.exports = {"detail_header":"index_detail_header_3wBN0","detail_body":"index_detail_body_13aM_","line":"index_line_ONKFn","form_control":"index_form_control_1_tUD"};